import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['wip--side-bar']
  static targets = ['frame']

  show(event) {
    event.preventDefault()

    const url = event.params.url
    if (!url) return

    const sidebarOpen = this.hasWipSideBarOutlet && this.wipSideBarOutlet.isOpen()
    const sameUrl = this.hasFrameTarget && this.frameTarget.src === new URL(url, window.location.origin).href

    if (sidebarOpen && sameUrl) {
      this.wipSideBarOutlet.close()
      return
    }

    if (this.hasFrameTarget) {
      this.frameTarget.src = url
    }

    if (this.hasWipSideBarOutlet && !sidebarOpen) {
      this.wipSideBarOutlet.open()
    }
  }
}
